import { Button } from '@klickly/front-packages';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
    && {
        padding-left: 0;
        border: none;
    }
`;
